import styled from 'styled-components';
import { Banner, TrevorIcon } from '@trevor/ui-components';

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
  align-items: center;
  margin-bottom: var(--spacing-l);
  margin-top: 28px;
  text-align: center;
`;

export const ErrorDisplayerContainer = styled.div`
  background: var(--color-interface-layout-lightest);
  height: 100%;
  width: min-content;
  padding: calc(var(--spacing-m) * 2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CopyIcon = styled(TrevorIcon).attrs({ name: 'copy' })`
  margin-left: var(--spacing-s);
  cursor: pointer;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: var(--spacing-m);
  align-items: center;
`;

export const ChatWithUs = styled.a`
  color: var(--color-interface-secondary-normal);
  text-decoration: underline;
  text-underline-offset: var(--spacing-xxs);
  cursor: pointer;

  > svg {
    margin-left: var(--spacing-s);
  }
`;

export const ErrorIdBanner = styled(Banner).attrs({ severity: 'info' })`
  > span {
    white-space: nowrap;
  }
`;
